"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initTracking = void 0;
var applicationinsights_web_1 = require("@microsoft/applicationinsights-web");
function initTracking(config) {
    var appInsights = new applicationinsights_web_1.ApplicationInsights({
        config: {
            //default instrumentationKey to empty string if not provided. Not setting the property, or setting to null causes errors even when disableTelemetry and disableInstrumentationKeyValidation are set to true
            instrumentationKey: config.instrumentationKey
                ? config.instrumentationKey
                : "",
            extensions: config.extensions,
            extensionConfig: config.extensionConfig,
            disableTelemetry: !config.instrumentationKey,
            disableInstrumentationKeyValidation: !config.instrumentationKey,
        },
    });
    appInsights.loadAppInsights();
    return appInsights;
}
exports.initTracking = initTracking;
exports.default = initTracking;
